import React, { Component } from 'react';
import './Item.css'
import ImportMasterData from '../../stock/ImportMasterData'
import {connect} from 'react-redux'
class Item extends Component {

  constructor(props) {
    super(props)

    this.state = {}
  }

  componentDidMount() {
    // this.refs.wageItemPopup.getWrappedInstance().openPopup()
  }

  onItemSelect() {

  }

  render() {
    return(
  		<div>
        <h3>นำเข้าข้อมูลคลังสินค้า</h3>
        <ImportMasterData 
          ref='importMasterData'
        />
  		</div>
  	)
  }

}
 
// export default Item;
export default Item = connect(
  (state) => ({messages: state.message.view.settings.Menu12.Item}),null,null,{withRef:true}
)(Item);



// WEBPACK FOOTER //
// ./src/view/settings/Menu12/Item.js